class GalleryMediaRevealJkl extends HTMLElement {
  connectedCallback() {
    this.dataset.expanded ??= "false";
    this.button = this.querySelector("[data-gallery-reveal-button-jkl]");
    this.button?.addEventListener("click", this.handleClick);
  }

  disconnectedCallback() {
    this.button?.removeEventListener("click", this.handleClick);
  }

  handleClick = (event) => {
    event.preventDefault();

    const expanded = this.dataset.expanded === "true";

    this.dataset.expanded = expanded ? "false" : "true";
    this.button?.setAttribute("aria-expanded", this.dataset.expanded);
  };
}

if (!customElements.get("gallery-media-reveal-jkl")) {
  customElements.define("gallery-media-reveal-jkl", GalleryMediaRevealJkl);
}
